<ion-toolbar>
	<div *ngIf="corners" class="toolbar-corners toolbar-top-corners hum-content">
		<div class="left-toolbar-corner toolbar-corner"></div>
		<div class="right-toolbar-corner toolbar-corner"></div>
	</div>
	<ng-content></ng-content>
</ion-toolbar>
